import { isHolidayNoticeVisible } from '@/lib/experienceLaunch';
import { useEffect, useState } from 'react';

export function useHolidayNotice() {
  const [isVisible, setIsVisible] = useState(() => isHolidayNoticeVisible());

  useEffect(() => {
    const sync = () => setIsVisible(isHolidayNoticeVisible());
    sync();

    const intervalId = window.setInterval(sync, 60_000);
    return () => window.clearInterval(intervalId);
  }, []);

  return isVisible;
}
